"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OKX_CONNECT_ERROR_CODES = exports.OkxConnectError = void 0;
var okx_connect_error_1 = require("./okx-connect.error");
Object.defineProperty(exports, "OkxConnectError", { enumerable: true, get: function () { return okx_connect_error_1.OkxConnectError; } });
Object.defineProperty(exports, "OKX_CONNECT_ERROR_CODES", { enumerable: true, get: function () { return okx_connect_error_1.OKX_CONNECT_ERROR_CODES; } });
